module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      H. Rider Haggard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("H. Rider Haggard (1856–1925) was an English adventure novelist. Haggard studied law, but rather than pursuing a legal career took a secretarial position in what is now South Africa. His time there provided the inspiration for some of his most popular novels, including "), _c('I', [_vm._v("She")]), _vm._v(" (1887), an early classic of the lost world fantasy genre and one of the bestselling books of all time.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Crm5fo/tc-custom/9781504084376.jpg?1705231657150",
      "alt": "This image is the cover for the book Nada the Lily"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Nada the Lily\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The son of a Zulu king teams up with a spectral wolf king to fight for honor and the woman he loves in this classic adventure tale by the author of "), _c('i', [_vm._v("She.")])])]), _c('p', [_c('i', [_vm._v("Nada the Lily")]), _vm._v(" tells the story of Umslopogaas, a fierce young Zulu warrior. He is the son of Chaka, the great Zulu king and general, and love of Nada the Lily, the most beautiful of the Zulu women. ")]), _vm._v(" When Chaka orders Umslopogaas’s death, the young man flees for his life, only to be carried away by a lion. He is saved by Galazi, king of an army of ghost-wolves. Together, they fight for glory and honor, armed with the fabled weapons, the axe Groan-maker and a club named Watcher of the Fords. But even with all the power they yield together, they may not be ready when Chaka sends an army out to slay them . . .\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0